import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader, MiniLoader } from '@pwc/pwc-deals-ui';
import AnalysisItem from '../AnalysisItem/AnalysisItem';
import { deleteAnalysis } from '../../services/groupsService.ts';
import ModalConfirmation from '../../../../common/components/ModalConfirmation';
import LoadMoreAnalysesButton from '../LoadMoreAnalysesButton/LoadMoreAnalysesButton';
import EmptyMessage from '../EmptyMessage/index.tsx';
import AutoLock from '../../../../common/components/AutoLock';

const AnalysesNoGroupingList = ({
  projectId,
  tags,
  analysisCount,
  setAnalysisCount,
  permissions,
  analyses,
  setAnalyses,
  isLoading,
  fetchAnalyses,
  pageRef,
  sortByRef,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const { t } = useTranslation();
  // Delete Analyses modal states
  const [modalDeleteAnalysis, setModalDeleteAnalysis] = useState(false);
  const [currentAnalysisToBeDeleted, setCurrentAnalysisToBeDeleted] =
    useState(null);

  projectId = parseInt(projectId, 10);

  useEffect(() => {
    setShowLoadMore(
      !isLoading && analyses.length < analysisCount && analysisCount > 0
    );
  }, [analysisCount, analyses.length, isLoading]);

  useEffect(() => {
    if (isLoading) {
      setAnalyses([]);
    }
  }, [isLoading, setAnalyses]);

  const handleDeleteAnalysisButton = (id) => {
    setCurrentAnalysisToBeDeleted(id);
    setModalDeleteAnalysis(true);
  };

  const handleDeleteAnalysis = async () => {
    try {
      const response = await deleteAnalysis(
        projectId,
        currentAnalysisToBeDeleted
      );

      if (response) {
        setAnalyses(
          analyses.filter(
            (analysis) =>
              analysis.contentThreadId !== currentAnalysisToBeDeleted
          )
        );
        setAnalysisCount(analysisCount - 1);
      }
    } catch (error) {
      // eslint-disable-next-line
      console.log('error', error);
    }

    setCurrentAnalysisToBeDeleted(null);
    setModalDeleteAnalysis(false);
  };

  const handleLoadMore = useCallback(async () => {
    pageRef.current += 1;
    setShowLoader(true);
    setShowLoadMore(false);
    await fetchAnalyses(tags, sortByRef.current);
    setShowLoader(false);
  }, [fetchAnalyses, tags, sortByRef, pageRef]);

  if (isLoading) {
    return <Loader />;
  }

  const ids = (analyses || []).map((a) => a.contentThreadId);

  return (
    <>
      <div
        className="analyses-no-grouping-view-container"
        data-testid="content-list"
      >
        <ModalConfirmation
          show={modalDeleteAnalysis}
          centered
          onCancel={() => setModalDeleteAnalysis(false)}
          onConfirm={() => {
            setModalDeleteAnalysis(false);
            handleDeleteAnalysis();
          }}
          confirmTitle={t('areyouSureDeleteMsg')}
          confirmationMessage={t('selectedAnalysesWillBeDeleted')}
          confirmButtonText={t('yesDelete')}
        />
        {!isLoading && (
          <EmptyMessage
            groupType="none"
            groupsCount={0}
            analysisCount={analyses.length}
          />
        )}
        <AutoLock projectId={projectId} contentThreadIds={ids}>
          {analyses &&
            analyses.length > 0 &&
            analyses.map((item, index) => (
              <AnalysisItem
                key={item.title}
                index={index}
                projectId={projectId}
                contentId={item.contentId}
                handleDelete={handleDeleteAnalysisButton}
                item={item}
                isNoneGroup
                permissions={permissions}
              />
            ))}
        </AutoLock>
        {showLoadMore && (
          <LoadMoreAnalysesButton handleLoadMore={handleLoadMore} />
        )}
        {showLoader && <MiniLoader />}
      </div>
    </>
  );
};

export default AnalysesNoGroupingList;
